import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { type WorkspaceIdentity } from '@modules/common/services/workspace-identity.service';
import { itemWorkspace, type WorkspaceItem } from './item-workspace-scope';

@Component({
  selector: 'app-item-team-label',
  template: `@if (team()) {
    <span class="text-sm text-subdued">{{ identity()?.spaceTitle }}</span>
  }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemTeamLabelComponent {
  public readonly revision = input(0);
  public readonly identity = input<WorkspaceIdentity>();
  public readonly item = input<WorkspaceItem>();
  protected readonly team = computed(() => {
    this.revision();
    return itemWorkspace(this.identity(), this.item()) === 'team';
  });
}
